"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TonContractFactory = void 0;
const ton_core_1 = require("ton-core");
const TonInitData_1 = require("./TonInitData");
class TonContractFactory {
    constructor(contractType) {
        this.contractType = contractType;
    }
    async makeForExecute(network, address) {
        const contract = new this.contractType(ton_core_1.Address.parse(address));
        await contract.connect(network);
        return contract;
    }
    async makeForDeploy(code, network, initData) {
        const { address, contract } = this.openContractCode(code, network.workchain, initData ?? new TonInitData_1.TonInitData());
        if (await network.isContractDeployed(address)) {
            throw "Contract already deployed";
        }
        await contract.connect(network);
        return contract;
    }
    openContractCode(code, workchain, initData) {
        const data = initData.toCell();
        const address = (0, ton_core_1.contractAddress)(workchain, { code, data });
        const contract = new this.contractType(address, { code, data });
        return { address, contract };
    }
}
exports.TonContractFactory = TonContractFactory;
//# sourceMappingURL=TonContractFactory.js.map